module.exports = __webpack_public_path__ + "img/icon_yqzg.ba518bd7.png";